import clsx from 'clsx';
import { FunctionComponent, ReactNode } from 'react';
import styles from './ListCard.module.scss';

interface ListCardProps {
    className?: string;
    children?: ReactNode;
}

// Composable card for mobile list items (ops tasks, belongings, ...). Domain-agnostic: consumers
// stack `ListCardRow`s with whatever content each list needs; consecutive rows auto-divide.
export const ListCard: FunctionComponent<ListCardProps> = props => {
    return <div className={clsx(styles.card, props.className)}>{props.children}</div>;
};

export default ListCard;
